import { useEffect, useState } from "react";
import Color from "./color";
import styles from "./styles.module.css";

export default function Shadow({ value, onChange }) {
  const [_value, setValue] = useState([]);

  useEffect(() => {
    if (value) {
      setValue(value.split(" "));
    } else {
      setValue("0px 0px 0px 0px rgba(0,0,0,0)".split(" "));
    }
  }, [value]);

  const handleUpdate = (v, i) => {
    if (i === 4) {
      const value = [..._value];
      value[i] = v;
      setValue(value);
      onChange(value.join(" "));
    } else {
      const value = [..._value];
      value[i] = v + "px";
      setValue(value);
      onChange(value.join(" "));
    }
  };

  if (_value.length === 0) {
    return null;
  }
  return (
    <div>
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: 4 }} className={styles.shadowSection}>
          <div className={styles.rangeTitle}>Horizontal Offset</div>
          <input
            className="input"
            type="number"
            value={_value[0].replace("px", "")}
            onChange={(e) => handleUpdate(e.target.value, 0)}
          />
        </div>
        <div style={{ marginLeft: 4 }} className={styles.shadowSection}>
          <div className={styles.rangeTitle}>Vertical Offset</div>
          <input
            className="input"
            type="number"
            value={_value[1].replace("px", "")}
            onChange={(e) => handleUpdate(e.target.value, 1)}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 8 }}>
        <div className={styles.shadowSection}>
          <div className={styles.rangeTitle}>Color</div>
          <Color value={_value[4]} onChange={(v) => handleUpdate(v, 4)} />
        </div>
        <div style={{ marginRight: 4 }} className={styles.shadowSection}>
          <div className={styles.rangeTitle}>Blur</div>
          <input
            className="input"
            type="number"
            value={_value[2].replace("px", "")}
            onChange={(e) => handleUpdate(e.target.value, 2)}
          />
        </div>
        <div className={styles.shadowSection}>
          <div className={styles.rangeTitle}>Spread</div>
          <input
            className="input"
            type="number"
            value={_value[3].replace("px", "")}
            onChange={(e) => handleUpdate(e.target.value, 3)}
          />
        </div>
      </div>
    </div>
  );
}
